<template>
	<b-container 	class="no-padding"
					v-if="lat !== null && lon !== null">
		<b-row>
			<b-col>
				<b-form-group
					label="Längengrad"
					label-for="lat">
					<b-form-input id="lat"
						type="text"
						disabled
						v-model.trim="lat">
					</b-form-input>
				</b-form-group>						
			</b-col>
			<b-col>
				<b-form-group
					label="Breitengrad"
					label-for="lon">
					<b-form-input id="long"
						type="text"
						disabled
						v-model.trim="lon">
					</b-form-input>
				</b-form-group>						
			</b-col>
		</b-row>				
		<b-row>
			<b-col>
				<transition name="fade"
							mode="out-in">
					<div 	class="map-wrapper"
							>
						<map-location-selector
							v-if="showMap"
							v-bind:latitude="lat" 
							v-bind:longitude="lon"
							@locationUpdated="locationUpdated">
						</map-location-selector>				
					</div>
				</transition>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<div class="space20"></div>
				Verschieben Sie die Karte um die rote Stecknadel im Bedarfsfall anders zu platzieren.
				<div class="space20"></div>
			</b-col>
		</b-row>
		
	</b-container>
</template>

<script>
// Organize imports
import MapLocationSelector from 'vue-google-maps-location-selector';

export default {
	data: function() {
		return {
			lat: null,
			lon: null,
			showMap: true,
		};
	},
	methods: {
		locationUpdated: function(location) {
			this.lat = location.lat;
			this.lon = location.lng;
		},
		defineInitialLocation: function(initialLocation) {
			// Extract adress data from prop
			var street = initialLocation.street;
			var houseNumber = initialLocation.houseNumber;
			var zip = initialLocation.zip;
			var city = initialLocation.city;

			/*
      if (typeof initialLocation.lat !== 'undefined' && typeof initialLocation.lon !== 'undefined') {
        // If lat and lon are set as prop (the object already has geo-coordinates in the database), use them instead of rerunning the Google Maps request
        this.lat = initialLocation.lat;
        this.lon = initialLocation.lon;
      } else {
      */
      if(street.length > 2 && houseNumber.length > 0 && zip.length > 2 && city.length > 1) {
        // Fire get request to server
        this.$http.post('utils/geocode', {
          street: street,
          houseNumber: houseNumber,
          zip: zip,
          city: city,
        }).then(result => {
          if(typeof result.body.results[0].geometry.location !== 'undefined') {

            // Check if the coordinates have changed and make the map update
            if(this.lat !== result.body.results[0].geometry.location.lat || this.lon !== result.body.results[0].geometry.location.lng) {

              // Write the coordinates into the variables
              this.locationUpdated({
                lat: result.body.results[0].geometry.location.lat,
                lng: result.body.results[0].geometry.location.lng,
              });

              // Refresh map if the coordinates have changed
              this.refreshMap();
            }
          }
        }, response => {
          // console.log('error', response);
        });
      }
    },
		emitLocation: function() {
			// Send the location to the parent element
			this.$emit('input', {
				lat: this.lat,
				lon: this.lon,
			});
		},
		refreshMap: function() {
			var _this = this;
			
			// Destroy and rebuild map
			this.showMap = false;			
			setTimeout(function() {
				_this.showMap = true;
			}, 1);
		},
	},
	watch: {
		initialLocation: function() {
			this.defineInitialLocation(this.initialLocation);
		},
		lat: function() {
			this.emitLocation();
		},
		lon: function() {
			this.emitLocation();
		},
	},
	props: {
		initialLocation: {
			default: null,
		},
	},
	components: {
		'map-location-selector': MapLocationSelector,
	}
}
</script>

<style scoped>
.map-wrapper {
	height: 250px;
}
.map-container {
	height: 100%;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/98_ui/MapsLocationSelector.vue